export enum verbandbuchModel {
  SINGULAR = "Verbandbuch",
  PLURAL = "Verbandbücher",
  ROUTE = "/everbandbuch",
  ICON = "mdi-hospital-box-outline",
  ITEM_KEY = "verbandbuch",
  ITEM_KEY_UPDATE = "verbandbuch",
}
